import { useMemo } from 'react';

import { useRoleIds } from '@/contexts/ConfigContext';

export const RoleName = ({ roleId }: { roleId?: string }) => {
  const roleIds = useRoleIds();

  const roleName = useMemo(() => {
    if (!roleId) return null;

    switch (roleId) {
      case roleIds.sysAdmin:
        return 'Systemadmin';

      case roleIds.orgAdminWrite:
      case roleIds.orgBearerManager:
      case roleIds.orgAdminRead:
        return 'Organisationsadmin';

      case roleIds.deptUser:
        return 'Avdelningsadmin';
      default:
        return null;
    }
  }, [roleId, roleIds]);

  return roleName;
};
